module.exports = __webpack_public_path__ + "static/menu-design-e2ceeaa76ec2a7a2c6f6f3b3b361fdcb.jpg";